(function () {
    'use strict';

    angular.module('app').controller('BriefCreateController', BriefCreateController);

    function BriefCreateController(
        $scope,
        $rootScope,
        $timeout,
        $state,
        $stateParams,
        BriefService,
        SeasonService,
        UserService,
        LinePlanService,
        WorkflowService,
        toaster,
        cfpLoadingBar,
        SharedData
    ) {
        var model = this;

        model.isDisabled = true;
        model.parentBriefSeasonalId = $stateParams.parentBriefSeasonalId || 0;
        model.paramLinePlanId = $stateParams.linePlanId || 0;
        model.radioValue = '';
        model.linePlanCount = -1;
        model.newBriefSeason = {};
        model.pageNumber = 1;
        model.pageSize = 50;
        model.hasBriefEditPermission = false;

        var hasCreatePermission = false;

        $scope.parentBriefSeasonalId = $stateParams.parentBriefSeasonalId || 0;
        $scope.paramLinePlanId = $stateParams.linePlanId || 0;
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 3) {
                if (userPermissionRow[1] == 3) {
                    hasCreatePermission = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.hasBriefEditPermission = true;
                }
            }
        });

        if (hasCreatePermission !== true) {
            $state.go('permissionDenied');
        }

        function getBrands() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    model.brands = response.brands;
                    model.seasons = response.seasons;
                    model.newBriefSeason.selectedBrand = response.brandId;
                    model.newBriefSeason.selectedSeason = response.seasonId;

                    if (response.brandId) {
                        model.selectBrand(response.brandId);
                    }

                    if (response.seasonId) {
                        var resetFilter = true;
                        model.loadLinePlans(resetFilter);
                    }
                }
                cfpLoadingBar.complete();
            });
        }

        function getSeasonsByBrand(brandId) {
            if (brandId) {
                SeasonService.getSeasonsByBrand(brandId).then(function(data) {
                    model.seasons = data;
                });
            }
        }

        function getUsersByBrand(brandId) {
            if (brandId) {
                UserService.getUsersByBrand(brandId).then(function(data) {
                    model.users = data;
                });
            }
        }

        function getWFGroups(brandId, defaultVal) {
            if (brandId) {
                WorkflowService.getWFGroups(brandId, 2).then(function(data) {
                    cfpLoadingBar.complete();
                    model.groups = data;
                    if (typeof defaultVal !== 'undefined') {
                        angular.forEach(model.groups,
                            function(groupRow) {
                                if (groupRow.WFGroupId == defaultVal) {
                                    model.newBriefSeason.selectedGroup = groupRow;
                                }
                            });
                    }
                });
            }
        }

        model.checkBriefName = function () {
            var briefId = 0;
            var briefName = model.newBriefSeason.briefName;

            if (model.newBriefSeason.selectedBrand && model.newBriefSeason.selectedSeason) {
                toaster.clear();

                BriefService.isBriefNameExists(
                    briefId,
                    briefName,
                    model.newBriefSeason.selectedBrand,
                    model.newBriefSeason.selectedSeason
                ).then(function (response) {
                    if (response == true) {
                        toaster.pop({
                            type: 'note',
                            title: 'Name Duplication',
                            body: 'You may continue, but please note this name already exists.',
                            timeout: 5000
                        });
                    }
                });
            }
        };

        model.selectBrand = function (brandId) {
            model.newBriefSeason.Responsible = '';
            model.linePlans = '';
            model.linePlanCount = 0;

            model.isDisabled = !brandId;

            getSeasonsByBrand(brandId);
            getUsersByBrand(brandId);
            getWFGroups(brandId);

            var resetFilter = true;
            model.loadLinePlans(resetFilter);
        };

        model.resetFilter = function () {
            model.linePlanId = 0;
            model.radioValue = 0;
            $scope.filterText = '';
        };

        model.loadLinePlans = function (resetFilter) {
            if (resetFilter) {
                model.resetFilter();
            }

            var brandId, seasonId;

            if (model.parentBriefSeasonalId == 0 && model.paramLinePlanId == 0) {
                brandId = model.newBriefSeason.selectedBrand;
            }

            if (model.parentBriefSeasonalId > 0) {
                brandId = model.briefDetails.BrandId;
            }

            if (model.paramLinePlanId > 0) {
                brandId = model.linePlanInfo.BrandId;
            }

            if (model.paramLinePlanId == 0) {
                seasonId = model.newBriefSeason.selectedSeason || 0;
            }

            if (model.paramLinePlanId > 0) {
                seasonId = model.linePlanInfo.SeasonId;
            }

            if (seasonId > 0 && brandId > 0) {
                model.getLinePlansByBrandSeason(brandId, seasonId, model.paramLinePlanId);
            }

            model.linePlanId = false;
        };

        model.setLinePlan = function (linePlan) {
            if (linePlan.StatusId == 2 || linePlan.StatusId == 3) {
                model.linePlanId = linePlan.LinePlanId;
                model.radioValue = linePlan.LinePlanId;
                model.selectedItem = linePlan;

                var brandId = linePlan.BrandId;

                getSeasonsByBrand(brandId);
                getUsersByBrand(brandId);
                getWFGroups(brandId);
            }
        };

        model.loadLinePlanPage = function (pageNumber, pageSize) {
            model.pageNumber = pageNumber;
            model.pageSize = pageSize;
            model.loadLinePlans(false);
        };

        var filterTimer;
        $scope.$watch('filterText', function (newValue) {
            if (newValue == null) {
                return;
            }

            model.pageNumber = 1; //set page number to one immediately on change

            $timeout.cancel(filterTimer);

            filterTimer = $timeout(function () {
                var brandId = model.newBriefSeason.selectedBrand ? model.newBriefSeason.selectedBrand : 0;
                var seasonId = model.newBriefSeason.selectedSeason ? model.newBriefSeason.selectedSeason : 0;
                var linePlanId = 0;
                var autoSelect = true;
                if (brandId > 0 && seasonId > 0) {
                    $scope.gridLoading = true;
                    model.getLinePlansByBrandSeason(brandId, seasonId, linePlanId, autoSelect);
                }
            }, 250);
        });

        $scope.validateAccountable = function (obj, prop) {
            if (!obj) return;

            prop = prop || "Responsible";

            //If its not an object or doesn't have the correct property theres nothing we can do.
            if (typeof obj !== "object" || !obj.hasOwnProperty(prop)) {
                return;
            }

            //If it doesn't look like a user (has an Id property with a value > 0) we will set the prop to null;
            //Otherwise it will pass.
            if (!obj[prop].hasOwnProperty("Id") || obj[prop].Id <= 0) {
                obj[prop] = null;
            }
        };

        model.setWindowGridHeight = function () {
            if (window.innerHeight >= 768) {
                $scope.windowGridHeight = window.innerHeight - 512;
            } else if ($scope.pagerData) {
                var size =
                    $scope.pagerData.TotalRecords < $scope.pagerData.PageSize
                        ? $scope.pagerData.TotalRecords
                        : $scope.pagerData.PageSize;
                $scope.windowGridHeight = size * model.gridOptions.rowHeight + 46;
            }
        };

        model.getLinePlansByBrandSeason = function (brandId, seasonId, linePlanId, autoSelect) {
            var searchObject = {
                BrandId: brandId,
                SeasonId: seasonId,
                LinePlanId: linePlanId === 0 ? null : linePlanId,
                StatusId: 2,
                StatusIdSecondary: 3,
                LinePlanName: $scope.filterText,
                SortColumn: 'LinePlanName',
                SortDirection: 'Asc'
            };

            $scope.gridLoading = true;

            LinePlanService.searchLinePlans(searchObject, model.pageNumber, model.pageSize)
                .then(function (response) {
                    if (response.results) {
                        model.linePlans = response;

                        //build pagerdata without results
                        $scope.pagerData = {
                            CurrentPageNumber: model.linePlans.currentPage,
                            PageSize: model.linePlans.pageSize,
                            TotalPageCount: model.linePlans.totalPages,
                            TotalRecords: model.linePlans.totalRecords,
                            firstRecord: model.linePlans.firstRecord,
                            lastRecord: model.linePlans.lastRecord
                        };

                        ////if there is only one line plan then select and hightlight the row
                        if (response.results.length == 1 && !autoSelect) {
                            model.setLinePlan(response.results[0]);
                        }

                        model.setWindowGridHeight();
                    } else {
                        model.linePlans = '';
                    }
                })
                .finally(function () {
                    $scope.gridLoading = false;
                });
        };

        model.createBriefSeason = function (isFormInvalid) {
            if (isFormInvalid || !model.linePlanId) {
                $scope.briefCreateForm.$setPristine();

                var validation1 = isFormInvalid ? 'Please review all fields indicated in red.' : '';
                var validation2 = !model.linePlanId
                    ? (validation1 !== '' ? ' And ' : '') + 'Select a Line Plan that is in Released Status.'
                    : '';

                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: validation1 + validation2,
                    timeout: 4000
                });
                return;
            }

            var createReq = {
                LinePlanId: model.linePlanId,
                ParentBriefSeasonalId: model.parentBriefSeasonalId,
                BriefName: model.newBriefSeason.briefName,
                BrandId: model.newBriefSeason.selectedBrand,
                SeasonId: model.newBriefSeason.selectedSeason,
                ResponsibleId: model.newBriefSeason.Responsible.Id,
                WFGroupId: model.newBriefSeason.selectedGroup.WFGroupId
            };

            if (model.paramLinePlanId > 0) {
                createReq.BrandId = model.linePlanInfo.BrandId;
                createReq.SeasonId = model.linePlanInfo.SeasonId;
            } else if (model.parentBriefSeasonalId > 0) {
                createReq.BrandId = model.briefDetails.BrandId;
                createReq.SeasonId = model.newBriefSeason.selectedSeason;
            }

            BriefService.createBriefSeasonal(createReq)
                .then(function (response) {
                    var nextView = 'brief';

                    $state.go(nextView, {
                        briefSeasonalId: response.briefSeasonalId
                    });

                    toaster.pop({
                        type: 'success',
                        title: 'Success!',
                        body: 'Brief ' + response.operationType.toLowerCase() + ' successfully.',
                        timeout: 5000
                    });
                })
                .catch(function (error) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body:
                            typeof error === 'string'
                                ? error
                                : 'There was an error while saving the record. Please contact system administrator.',
                        timeout: 5000
                    });
                })
                .finally(function () {
                    $scope.briefCreateForm.$setPristine();
                    $scope.briefCreateForm.$setUntouched();
                });
        };

        model.initCreatePage = function () {
            if (model.parentBriefSeasonalId == 0 && model.paramLinePlanId == 0) {
                getBrands();
            }

            if (model.paramLinePlanId > 0) {
                model.isDisabled = false;

                LinePlanService.getLinePlanHeaderInfo(model.paramLinePlanId)
                    .then(function (response) {
                        model.linePlanInfo = response;
                        model.newBriefSeason.selectedBrand = model.linePlanInfo.BrandId;
                        getUsersByBrand(model.linePlanInfo.BrandId);
                        getWFGroups(model.linePlanInfo.BrandId);

                        model.getLinePlansByBrandSeason(
                            model.linePlanInfo.BrandId,
                            model.linePlanInfo.SeasonId,
                            model.paramLinePlanId
                        );
                    })
                    .finally(function () {
                        cfpLoadingBar.complete();
                    });
            } else if (model.parentBriefSeasonalId > 0) {
                BriefService.getBriefCreateDetails(model.parentBriefSeasonalId)
                    .then(function (createDetails) {
                        model.groups = createDetails.groupList;
                        model.users = createDetails.users;
                        model.seasons = createDetails.seasons;

                        model.briefDetails = createDetails.briefDetails;

                        model.parentBriefId = model.briefDetails.BriefId;
                        model.newBriefSeason.selectedBrand = model.briefDetails.BrandId;

                        model.isDisabled = false;
                    })
                    .finally(function () {
                        cfpLoadingBar.complete();
                    });
            }
        };

        //model.initCreatePage();
    }
})();
